import { useBounds } from "@react-three/drei";
import React, { useEffect } from "react";

const MainModel = ({geom, material}) => {
  
  const bounds = useBounds();
  useEffect(()=>
  {
    //setTimeout(()=>{bounds.refresh().clip().fit();},100);
    bounds.refresh().clip().fit();
  },[geom.geometry]);
  
  return (
    <mesh
      visible={true}
      material={material}
      geometry={geom.geometry}
      position={geom.position}
      rotation={geom.rotation}
      scale={geom.scale}
      castShadow={true} receiveShadow={true}>
    </mesh>
  )
};

export default MainModel;
